module.exports = "<button class=\"btn btn-primary\" (click)=\"login()\">Login with Google</button>\r\n"